import React, { useEffect, useRef, useState } from 'react'
import { RouterProps, useLocation, useNavigate } from 'react-router-dom'
import './Drag.scss'
import { Header, Settings, Login } from '../components'
import { bindEvent } from '../modules/bindEvent'

import { useTranslation } from 'react-i18next'
import { Debounce, deepCopy } from '@nyanyajs/utils'
import { v5 as uuidv5, v4 as uuidv4 } from 'uuid'

import { api } from '../modules/http/api'

import store, {
  RootState,
  AppDispatch,
  useAppDispatch,
  methods,
  notesSlice,
  storageSlice,
  configSlice,
} from '../store'
import { useSelector, useDispatch } from 'react-redux'
import { createRouter } from '../modules/electron/router'
import { client } from '../store/nsocketio'
import { NoteItem } from '../store/notes/typings'
import { alert } from '@saki-ui/core'

const debounce = new Debounce()
// let timer: NodeJS.Timeout
const DragComponent = () => {
  const { t, i18n } = useTranslation()
  const config = useSelector((state: RootState) => state.config)
  const [showModal, setShowModal] = useState(false)

  const d = useRef(new Debounce())
  const dragNote = useRef(false)
  const dragging = useRef(false)

  useEffect(() => {
    const el = document.body
    console.log('el', el)
    if (!el) return
    el.addEventListener('dragover', dragoverEvent)
    el.addEventListener('dragleave', dragleaveEvent)
    el.addEventListener('drop', dragEvent)
    return () => {
      el.removeEventListener('dragover', dragoverEvent)
      el.removeEventListener('dragleave', dragleaveEvent)
      el.removeEventListener('drop', dragEvent)
    }
  }, [config.lang])

  const dragoverEvent = (e: DragEvent) => {
    const ele: HTMLDivElement = e.target as any
    // console.log(
    // 	'ele1',
    // 	ele,
    // 	e,
    // 	(e as any).dataTransfer.items,
    // 	(e as any).dataTransfer.items?.[0]?.kind,
    // 	ele?.classList.contains('saki-m-i-title')
    // )

    // console.log('dragNote.current dragoverEvent', dragNote.current)

    // if (!dragging.current) {
    // 	dragging.current = true
    // 	dragNote.current = !ele?.classList.contains('saki-m-i-title')
    // }

    // d.current.increase(() => {
    // 	dragNote.current && setShowModal(true)
    // }, 1)

    if ((e as any).dataTransfer.items?.[0]?.kind === 'file') {
      d.current.increase(() => {
        setShowModal(true)
      }, 1)
    }

    e.stopPropagation()
    e.preventDefault()
  }

  const dragleaveEvent = (e: DragEvent) => {
    console.log('dragNote.current dragleaveEvent', dragNote.current, e)
    e.stopPropagation()
    e.preventDefault()
    d.current.increase(() => {
      setShowModal(false)
    }, 100)

    // if ((e as any).dataTransfer.items.length) {
    // 	setShowModal(false)
    // }
  }

  const dragEvent = (e: any) => {
    e.stopPropagation()
    e.preventDefault()

    dragging.current = false
    dragNote.current = false

    setShowModal(false)
    const ele: HTMLDivElement = e.target
    console.log(
      'ele1',
      ele,
      e.dataTransfer.items,
      ele?.classList.contains('drag-main')
    )
    // if (ele?.classList.contains('drag-main')) {
    if (e.dataTransfer.items && ele?.classList.contains('drag-main')) {
      let items = new Array(...e.dataTransfer.items)
      // console.log(items)
      for (let index = 0; index < items.length; index++) {
        let e = items[index]
        let item = null
        if (e.webkitGetAsEntry) {
          item = e.webkitGetAsEntry()
        } else if (e.getAsEntry) {
          item = e.getAsEntry()
        } else {
          console.error('浏览器不支持拖拽上传')
          return
        }
        // console.log('itemitem', item)
        if (item?.isFile) {
          item.file((file: File) => {
            // console.log(file)
            if (
              file.name.substring(
                file.name.lastIndexOf('.'),
                file.name.length
              ) === '.note'
            ) {
              const fileReader = new FileReader()
              fileReader.onload = (e) => {
                try {
                  if (!e.target?.result) return
                  const data = String(e.target?.result)
                  const note: NoteItem = JSON.parse(data)
                  console.log('note', note)
                  if (note?.id) {
                    let isExist = false
                    const { notes, user } = store.getState()
                    notes.list.some((v) => {
                      console.log(v.id, note.id)
                      if (v.id === note.id) {
                        isExist = true
                        return true
                      }
                    })
                    note.syncTime = 0
                    console.log('isExist', isExist)
                    if (!isExist) {
                      store.dispatch(
                        notesSlice.actions.addNote({
                          v: {
                            ...note,
                            isSync: false,
                          },
                          disableSync: true,
                        })
                      )
                    } else {
                      alert({
                        title: t('importNotes', {
                          ns: 'common',
                        }),
                        content: t('noteAlreadyExistsOverwrite', {
                          ns: 'common',
                        }),
                        cancelText: t('cancel', {
                          ns: 'sakiuiPrompt',
                        }),
                        confirmText: t('import', {
                          ns: 'sakiuiPrompt',
                        }),
                        onCancel() {
                          // store.dispatch(
                          // 	notesSlice.actions.addNote({
                          // 		v: {
                          // 			...note,
                          // 			id: uuidv5(note.name, uuidv4()),
                          // 			authorId: user.userInfo.uid,
                          // 			isSync: false,
                          // 		},
                          // 		disableSync: true,
                          // 	})
                          // )
                        },
                        onConfirm() {
                          alert({
                            title: t('downloadNote', {
                              ns: 'indexPage',
                            }),
                            content: t('getNoteMergeOrReplaceContent', {
                              ns: 'indexPage',
                            }),
                            cancelText: t('replace', {
                              ns: 'indexPage',
                            }),
                            confirmText: t('merge', {
                              ns: 'indexPage',
                            }),
                            onCancel() {
                              store.dispatch(
                                notesSlice.actions.mergeNoteByCloud({
                                  id: note.id,
                                  v: {
                                    ...note,
                                    lastUpdateTime: Math.floor(
                                      new Date().getTime() / 1000
                                    ),
                                  },
                                  type: 'Replace',
                                })
                              )
                            },
                            onConfirm() {
                              store.dispatch(
                                notesSlice.actions.mergeNoteByCloud({
                                  id: note.id,
                                  v: {
                                    ...note,
                                    lastUpdateTime: Math.floor(
                                      new Date().getTime() / 1000
                                    ),
                                  },
                                  type: 'Merge',
                                })
                              )
                            },
                          }).open()
                        },
                      }).open()
                    }
                  }
                } catch (error) {
                  console.error(error)
                }
              }
              fileReader.readAsText(file)
            }
          })
        }
      }
    }
  }

  return (
    // <></>
    <saki-modal
      width="100%"
      height="100%"
      max-width="300px"
      max-height="200px"
      border-radius="10px"
      visible={showModal}
    >
      <div className="drag-component">
        <div data-methods="drag" className="drag-main">
          {t('dragArea', {
            ns: 'common',
          })}
        </div>
      </div>
    </saki-modal>
  )
}

export default DragComponent
